module.exports = __webpack_public_path__ + "static/media/s3.08726787.svg";